import React from 'react'
import utils from '../../utils'
import fetch from '../fetch'
import { Modal } from 'antd'

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback
}

const getSelection = () => {
    return DataGrid.selections
}

const prefixUrl = 'teacher/weighted/scoring'

const columns = utils.columns([
    {
        key: '$index',
        label: '序号'
    },
    {
        key: 'orgName',
        label: '所属部门'
    },
    {
        key: 'employeeCode',
        label: '教师工号'
    },
    {
        key: 'employeeName',
        label: '教师姓名'
    },
    {
        key: 'weightedScoring',
        label: '教师加权评分'
    },
    {
        key: 'termName',
        label: '所属学期'
    }
])

const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    return fetch.post(`${prefixUrl}/query?pageNum=${keywords.pageNum}&pageSize=${keywords.pageSize}&order=${keywords.order || ''}&sort=${keywords.sort || ''}`, keywords)
        .then(res => {
            const data = res.payload.data
            return Object.assign({
                result: data.dataList,
                selects: data.dataList.map(e => {
                    return {
                        value: e.id,
                        checked: false,
                    }
                }),
                checked: false,
                total: data.total,
                pageIndex: data.pageNum,
                pageSize: data.pageSize,
                notify: ([]).length ? '' : '暂无数据...'
            })
        })
}
//删除信息
const remove = (ids) => {
    return fetch.post(`${prefixUrl}/remove`, ids)
        .then(res => {
            if (res.code === 200) {
                return res.payload.data
            }
        })
}

//修改信息

const querySearchById = (id) => {

    return fetch.post(`${prefixUrl}/get`, id)
        .then(response => {
            if (response.code === 200) {
                return response.payload.data
            }
        })
}
const update = (data) => {
    return fetch.post(`${prefixUrl}/update`, data)
        .then(response => {
            return response
        })
}
export default {
    onSelect,
    setRefresh,
    getSelection,
    columns,
    querySearch,
    remove,
    querySearchById,
    update
}